export const COLUMN_TYPE = {
  selectWithCustomQuery: 'selectWithCustomQuery',
  selectWithStaticValues: 'selectWithStaticValues'
}